'use strict';

function ManagerService (SaturnGrowl) {

  //************ PUBLIC VARIABLES ************\\
  const moment = require('moment');
  this.JOB_DETAIL_STATE = 'manager.processingJobs.job';
  this.PROCESSING_STATES = [
    'Completed',
    'Processing',
    'Delayed'
  ];

  //************ PUBLIC METHODS ************\\
  this.generateGrowlData = (messageStub, idName) => {

    return {
      message: ['Your subscription has been', messageStub].join(' '),
      id: [idName, Date.now()].join('-'),
      time: 2500
    };
  };

  this.generateGrowlId = (status, user) => {

    const name = user.name.split(' ').join('').toLowerCase();

    return [name, status, Date.now()].join('-');
  };

  this.generateRequestGrowlMessage = (org, user, status) => {

    let name = user.name+ '\'';

    // only add 's to the end of the name if the name does not end in s
    if (name[name.length - 2] !== 's') {
      name += 's';
    }

    return [name, 'request to join', org.name, 'has been', status].join(' ');
  };

  /**
   * growl - description
   *
   * @param  {type} config object
   * Config MUST have message and id properties
   * *** AVAILABLE CONFIG SETTINGS ***
   * Message: {String} REQUIRED the text displayed in the growl
   * ID {String} REQUIRED internal growl identifier. should be unique to avoid conflicts with multiple growls being open simultaneously
   * Type {String} OPTIONAL determines the color of the growl. can be 'normal' (default), 'warning', or 'alert'
   * Time {Number} OPTIONAL the length of time (in milliseconds) that the growl will remain open. -1 is infinite
   * @return {type}        N/A
   */
  this.growl = (config) => {

    SaturnGrowl.newGrowl(config.message, {
      type: config.type || 'normal',
      time: config.time || 10000,
      id: config.id
    });
  };


  this.transformStates = (obj) => {

    if (obj.state === 0 && !obj.organizationId) {
      // These jobs may not have the correct state, will refer to whether it has completed data captures
      // to determine if processing has completed

      if (obj.dataCapture && obj.dataCapture.dataCaptureLayers) {
        if (obj.dataCapture.dataCaptureLayers.length){
          obj.state = this.PROCESSING_STATES[0];
        }
        else {
          obj.state = this.PROCESSING_STATES[1];
        }
      }
      else {
        obj.state = this.PROCESSING_STATES[1];
      }

    }
    else {
      // These jobs are reflecting the correct processing job update state
      switch (obj.state) {
      case 0:
        obj.state = this.PROCESSING_STATES[1];
        break;
      case -1:
        obj.state = this.PROCESSING_STATES[2];
        break;
      default:
        obj.state = this.PROCESSING_STATES[0];
        break;
      }
    }
  };

  this.makeNiceDate = (utc) => {

    return moment(utc).format('M/D/YY h:mm A');
  };

  this.makeSimpleDate = (utc) => {

    return moment(utc).format('M/DD/YY');
  };

  this.makeNumberDate = (utc) => {

    return new Date(utc).getTime();
  };

  this.makeNiceJobData = (job, project, capture) => {

    this.transformStates(job);

    job.uploadedTime = this.makeNumberDate(job.createdAt);
    job.competedTime = this.makeNumberDate(job.updatedAt);
    job.createdAtTime = this.makeNiceDate(job.createdAt);
    job.updatedAtTime = this.makeNiceDate(job.updatedAt);
    if (project) {
      job.name = project.name;
      if (project.slug) {
        job.slug = project.slug;
      }
      else {
        job.slug = project.sites[0].slug;
      }
    }
    if (capture) {
      job.flightDate = this.makeSimpleDate(capture.capturedAt);
      job.capturedAtTime = this.makeNumberDate(capture.capturedAt);
      job.captureId = capture.id;
    }

    return job;
  };
}

ManagerService.$inject = ['SaturnGrowl'];

module.exports = ManagerService;



// WEBPACK FOOTER //
// ./src/app/manager/ManagerService.js